<template>
  <div class="container-input-form  col-sm" style="margin-bottom: 0;">
    <label class="label-form-css" for="donate-blood-to-date">{{ nameDatePiker }} :</label>
    <div class="block-dataPicker" style="display: flex;">
      <input
          type="text"
          class="form-control input-form-css input-form-datepicker"
          v-on:change.prevent="changeDate"
          v-on:focus="focusInput"
          v-bind:class="{'invalid-item':errorEvent}"
          id="donate-blood-to-date"
          placeholder="mm/dd/yyyy"
          aria-describedby="toDateHelp"
          v-model="inputsDate"
          v-mask="'##/##/####'"
      >
      <button
          type='button'
          class="button-datepicker hover-pointer"
          @click="openPicker"
      >
        <font-awesome-icon :icon="['fas', 'calendar-alt']" />
      </button>
    </div>
    <vuejs-datepicker
        class = "my"
        ref="programaticOpen"
        v-model.trim="inputsDate"
        @closed="datepickerClosed"
        format="dd MMMM yyyy"
    />
<!--    :format="customFormatter" -->

    <small id="toDateHelp" class="form-text text-muted">Required field.</small>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarAlt,  } from '@fortawesome/free-solid-svg-icons'
library.add(faCalendarAlt)

import vuejsDatepicker from 'vuejs-datepicker';
import moment from 'moment-timezone';
import {mask} from  'vue-the-mask';
export default {
  name: "datePiker",
  components: { vuejsDatepicker },
  props: ['dateDatePiker', 'nameDatePiker', "errorEvent"],

  data(){
    return {
      inputsDate: this.dateDatePiker,
    }
  },
  watch : {
    dateDatePiker: function(val){
      this.inputsDate = val;
    }
  },
  methods: {
    focusInput(){
      this.$root.$emit('focusInputDatePicker');
    },
    customFormatter: date => date?moment(date).format('MM/DD/YYYY') : '',
    changeDate(){
      this.inputsDate = moment(this.inputsDate).format('MM/DD/YYYY');
      this.$emit('changeDateDatePiker', this.inputsDate);
    },
    openPicker: function () {
      this.$refs.programaticOpen.showCalendar();
    },
    datepickerClosed: function () {
      this.inputsDate = moment(this.inputsDate).format('MM/DD/YYYY');
      this.$root.$emit('datePicker' + this.nameDatePiker.replace(/\s/g, ''), this.inputsDate);
    },
  },
  directives: {
    mask
  }
}
</script>
<style>
  .vdp-datepicker input{
    display: none;
  }

</style>
<style scoped>
.input-form-datepicker{
  z-index: 10;
  background: transparent;
}
.button-datepicker {
  position: absolute;
  right: 11px;
  /* height: 70px; */
  height: 35px;
  background-color: transparent;
  border: hidden;
  z-index: 20;
}
.block-dataPicker{
  position: relative;
}
.button-datepicker{
  background-color: #fff;
  margin-top: 1px;
}
.button-datepicker svg {
  color: var(--BasicFontColor);
  border-color: #fff;
}
.button-datepicker:active svg, .button-datepicker:focus svg, .button-datepicker:hover svg {
  color: #c9c76d;
}
</style>
